import { CDP_INITIATIVE } from "@/constants/app";
import { useIsNewBuildProject } from "@/shared/hooks";
import { useCardTracking } from "@aviv-classified-card/card/full";
import { useTrackingEventsDatasNoItems } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingCardClick = (id) => {
    const tracking = useCardTracking(id);
    const isNewBuildProject = useIsNewBuildProject();
    const EVENT_DATA = Object.assign(Object.assign({ event: "select_item", av_items: [tracking] }, useTrackingEventsDatasNoItems()), { av_initiative: isNewBuildProject ? "wl_pdp" : CDP_INITIATIVE });
    const thorEvent = useTrackingEvent(EVENT_DATA);
    return () => thorEvent();
};
